export const fetchOpts = (method: string): RequestInit => ({
  method: method,
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'same-origin',
  redirect: 'follow',
  referrer: 'no-referrer'
});
